import type { AuthenticatedUser } from "@gettactic/api";

/**
 * Who sees the native Analytics: owners and report managers. The
 * organization's reporting flag decides whether the facts are computed at
 * all and is checked by the callers; this decides who gets the page, the
 * menu entry and the search rows once the flag is on.
 */
export const canAccessAnalytics = (
  authenticatedUser: AuthenticatedUser | undefined
): boolean => {
  const roles = authenticatedUser?.user?.organization_user?.roles ?? [];
  return roles.includes("owner") || roles.includes("report_manager");
};
